export default __webpack_public_path__ + "static/media/img-slider-banpu-power-4.d8b61ae7.png";